import React, { useState } from "react";

// expand if something needed
export interface IImageProps {
  src: string;
  fallbackSrc: string;
  alt?: string;
  height?: number;
  width?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const Image = (props: IImageProps): JSX.Element => {
  const [src, setSrc] = useState<string>(props.src);

  const { fallbackSrc, alt, height, width, className, style } = props;

  const handleError = (): void => {
    setSrc(fallbackSrc);
  };

  return (
    <img
      src={src}
      alt={alt}
      height={height}
      width={width}
      className={className}
      onError={handleError}
      style={style}
    />
  );
};
